import { ark } from '@ark-ui/react/factory';
import type { ComponentProps } from 'react';
import { styled } from 'styled-system/jsx';

const StyledSvg = styled(ark.svg);

export type LoginIconProps = ComponentProps<typeof StyledSvg>;

export const LoginIcon = (props: LoginIconProps) => (
  <StyledSvg
    viewBox="0 0 60 60"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    width="60"
    height="60"
    {...props}
  >
    <g clipPath="url(#clip0_810_5359)">
      <rect width="60" height="60" rx="30" fill="#EFF2E3" />
      <g clipPath="url(#clip1_810_5359)">
        <path
          d="M58.2074 53.6551C56.0505 44.955 51.9734 48.5287 50.1618 45.9222C48.3501 43.3156 53.7632 40.7681 51.3115 36.8336C48.8599 32.8992 45.8286 36.1732 43.959 33.3333C42.0895 30.4934 47.2004 25.9235 44.3253 23.4153C41.4503 20.9072 38.9964 25.3685 37.0151 22.3911C35.0338 19.4137 39.2784 15.2232 35.3633 13.2207C33.1782 12.103 31.2507 13.8852 30.3548 15.5812C29.7402 16.7448 28.16 16.7995 27.4091 15.686C25.9125 13.4667 23.7114 11.0403 21.7122 12.0628C15.9463 15.0114 24.5391 21.2722 20.2401 23.9896C15.9411 26.707 18.9131 31.1731 21.298 31.0775C23.6828 30.9819 26.8853 33.2435 24.8134 36.4825C22.133 40.6728 24.0309 43.3075 26.2838 44.2939C28.16 45.1155 30.2028 46.6258 27.4648 50.9382C24.3066 55.9124 33.0268 59.8973 33.0268 59.8973L58.2072 53.655L58.2073 53.6552L58.2074 53.6551Z"
          fill="#7DBD2A"
        />
        <path
          d="M32.9312 36.9196C33.4259 36.6468 33.8985 36.398 34.3502 36.1698L37.0204 34.9296C40.1757 33.5796 42.31 32.9121 43.631 30.9425C44.1434 28.3406 46.4826 25.2977 44.3253 23.4155C43.3785 22.5895 42.4773 22.5195 41.6236 22.6907C40.2876 25.2942 37.3929 26.8556 33.1812 28.6978L30.2087 30.1009C27.8446 31.4474 26.3406 33.0908 25.4743 34.2766C25.5158 34.938 25.3266 35.6803 24.8133 36.4826C22.1329 40.6729 24.0308 43.3076 26.2837 44.2941C26.4246 44.3557 26.5663 44.4214 26.7069 44.4917C26.8141 43.6459 27.5836 39.8694 32.9312 36.9196Z"
          fill="#518500"
        />
        <path
          d="M27.1679 24.0775C31.9037 21.4652 34.7207 21.4528 36.4723 19.9778C36.6491 17.451 38.2974 14.7215 35.3634 13.2209C33.1783 12.1033 31.2508 13.8854 30.3549 15.5814C29.7403 16.745 28.1601 16.7997 27.4092 15.6862C25.9126 13.4668 23.7116 11.0405 21.7123 12.0628C15.9464 15.0114 24.5392 21.2722 20.2403 23.9897C16.3791 26.4305 18.3834 30.2811 20.5597 30.9708C21.0906 29.6569 22.7542 26.5122 27.1679 24.0775Z"
          fill="#518500"
        />
        <path
          d="M40.5293 50.4103L43.3352 49.0129C46.7426 47.7798 48.6584 46.7792 49.8901 45.3951C49.0453 42.9657 53.5978 40.5027 51.3115 36.8335C50.6611 35.7898 49.97 35.2535 49.2706 34.9756C47.8093 38.0239 45.7211 39.0062 40.7542 41.1786L37.2123 43.0869C32.8389 45.5777 28.9853 54.4251 28.1756 56.3789C29.6569 58.1014 31.8897 59.3273 32.7096 59.7423C33.4884 58.184 36.15 53.3516 40.5293 50.4103Z"
          fill="#518500"
        />
        <path
          d="M56.3507 49.2182C55.5853 51.1704 51.7999 54.3341 48.5698 56.0444L58.2074 53.6552C57.6822 51.5369 57.043 50.1476 56.3507 49.2182Z"
          fill="#518500"
        />
        <path
          d="M42.2323 57.6155C42.2257 57.5769 41.6356 53.4276 39.6494 47.8693C37.8238 42.7603 34.4792 35.1364 28.9141 27.8296C28.3993 27.1539 28.4895 26.1809 29.1154 25.6566C29.7414 25.1324 30.6663 25.2553 31.181 25.9312C37.0197 33.5972 40.5161 41.5821 42.4209 46.9308C44.4909 52.7426 45.1734 56.7133 45.2015 56.8795L42.2323 57.6156L42.2323 57.6155Z"
          fill="#6C7D56"
        />
        <g opacity="0.19">
          <path
            d="M20.3146 17.4446C21.0655 18.5581 22.6456 18.5034 23.2603 17.3398C23.8897 16.1482 25.0286 14.9157 26.408 14.6746C24.9812 12.8344 23.1604 11.2612 21.4818 12.1197C19.3214 13.2244 19.1769 14.7944 19.6147 16.4685C19.8611 16.7906 20.0956 17.1197 20.3146 17.4446Z"
            fill="#6C7D56"
          />
          <path
            d="M49.9311 45.9789C48.1194 43.3723 53.5325 40.8249 51.0808 36.8904C48.6292 32.9559 45.5979 36.23 43.7283 33.3901C41.8588 30.5502 46.9697 25.9803 44.0947 23.4721C41.2196 20.964 38.7657 25.4253 36.7844 22.4479C34.8031 19.4705 39.0477 15.2799 35.1326 13.2775C32.9475 12.1599 31.02 13.942 30.1241 15.638C29.9997 15.8733 29.8355 16.0625 29.6471 16.2066C30.8936 18.4046 28.2842 21.6906 29.9204 24.1495C31.9017 27.1269 34.3556 22.6656 37.2307 25.1737C40.1057 27.6819 34.9948 32.2517 36.8644 35.0917C38.7339 37.9316 41.7652 34.6576 44.2168 38.592C46.6684 42.5264 41.2554 45.074 43.0671 47.6806C44.8788 50.2872 48.9559 46.7134 51.1127 55.4136L57.9767 53.7119C55.8198 45.0117 51.7427 48.5854 49.9311 45.9789Z"
            fill="#6C7D56"
          />
        </g>
      </g>
    </g>
    <defs>
      <clipPath id="clip0_810_5359">
        <rect width="60" height="60" rx="30" fill="white" />
      </clipPath>
      <clipPath id="clip1_810_5359">
        <rect
          width="46.2988"
          height="49.2114"
          fill="white"
          transform="translate(8 15.4004) rotate(-13.9232)"
        />
      </clipPath>
    </defs>
  </StyledSvg>
);
